import { render } from "./Pharmacy.vue?vue&type=template&id=72a1d3c5&scoped=true"
import script from "./Pharmacy.vue?vue&type=script&lang=js"
export * from "./Pharmacy.vue?vue&type=script&lang=js"

import "./Pharmacy.vue?vue&type=style&index=0&id=72a1d3c5&lang=scss&scoped=scoped"

import exportComponent from "D:\\work\\粤智康医药网\\guanwang\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a1d3c5"]])

export default __exports__